const l = {
  name: "FormulaWinningIsMoreImportant",
  dimensions: { width: 30, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 40" style="enable-background:new 0 0 30 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.2,0h13.6l1,4H25v4h5v7c0,3.8-3.1,7-6.9,7l-1.2,8H16v4h5.8l1.5,6H6.7l1.5-6H14v-4H8.1l-1.2-8
			C3.1,22,0,18.8,0,15V8h5V4h2.2L8.2,0z M5.1,10H2v5c0,2.6,2,4.8,4.6,5L5.1,10z M7.2,10l2.7,18h10.3l2.7-18H18v2h2v6h-6v-6h2v-2H7.2
			z M23,8V6H7v2H23z M24.9,10l-1.5,10c2.6-0.2,4.6-2.4,4.6-5v-5H24.9z M20.2,2H9.8L9.3,4h11.4L20.2,2z M9.3,38h11.4l-0.5-2H9.8
			L9.3,38z M18,14h-2v2h2V14z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as FormulaWinningIsMoreImportant
};
